import styled from "styled-components";

export const SearchDate = styled.div`
  @media print {
    display: none;
  }
`;
export const SearchColumn = styled.div`
  @media print {
    display: none;
  }
`;
export const PdfDiv = styled.div`
  @media print {
    display: none;
  }
`;
